export default function (axios, api) {
  return {
    state: {
      events: [],
      event: {
        title: {
          rendered: null
        },
        background: { url: false }
      },
      cities: []
    },

    getters: {
      cities: state => state.cities,
      events: state => state.events,
      event: state => state.event,
      eventBg: state => state.event.background.url
    },

    actions: {
      getCities ({ commit }) {
        return api.fetchCities().then(cities => {
          commit('setCities', cities)
        })
      },

      getEvents ({ commit }, { page, scope, city }) {
        commit('setEvents', [])
        commit('setPagesTotal', 0)

        return api.fetchEvents({ page, scope, city }).then(({ events, pages }) => {
          commit('setEvents', events)
          commit('setPagesTotal', pages)
        })
      },

      getEvent ({ commit, getters }, slug) {
        commit('clearHero')
        commit('clearEvent')
        commit('clearTabs')

        return api.fetchEvent(slug).then(event => {
          let tabs = []

          if (event.invite.length > 0) {
            tabs.push({ title: 'Покана', link: { name: 'event-invite', params: { slug } } })
          }

          if (event.content.rendered.length > 0) {
            tabs.push({ title: 'Дневен ред', link: { name: 'event-agenda', params: { slug } } })
          }

          if (event.proposals.length > 0) {
            tabs.push({ title: 'Предложения', link: { name: 'event-proposals', params: { slug } } })
          }

          if (event.nominations.length > 0) {
            tabs.push({ title: 'Номинации', link: { name: 'event-nominations', params: { slug } } })
          }

          if (event.news.length > 0) {
            tabs.push({ title: 'Новини', link: { name: 'event-news', params: { slug } } })
          }

          if (event.questionnaire.length > 0) {
            tabs.push({ title: 'Гласуване', link: { name: 'event-voting', params: { slug } } })
          }

          const isUserEditor = getters.loggedIn && typeof window.cordova !== 'undefined' &&
            (getters.user.roles.indexOf('editor') > -1 || getters.user.roles.indexOf('administrator') > -1)

          if (isUserEditor) {
            tabs.push({ title: 'Check-In', link: { name: 'checkin', params: { slug } } })
          }

          commit('setTabs', tabs)
          commit('setEvent', event)
          commit('setHero', event.thumbnail)
        })
      },

      checkInUser ({ state }, { mandate, user }) {
        return api.checkInUser(state.event.id, user, mandate)
      }
    },

    mutations: {
      setEvents: (state, events) => (state.events = events),
      setEvent: (state, event)   => (state.event = event),
      setCities: (state, cities) => (state.cities = cities),

      clearEvent (state) {
        state.event = {
          title: {
            rendered: null
          },
          background: { url: false }
        }
      }
    }
  }
}
